import { helpers } from '@kurtosys/ksys-app-template';
import { StoreContext } from '../configuration/StoreContext';
import { Manifest } from '../configuration/Manifest';
import { TEMPLATE_STORE } from '../initialize';

export function getStoreContextForElement(element: HTMLElement, url: string, manifest: Manifest) {
	const storeKey = getStoreKey(element, url, manifest);
	if (!(window as any)[storeKey]) {
		(window as any)[storeKey] = new StoreContext(element, url, TEMPLATE_STORE, manifest);
	}
	const storeContext = (window as any)[storeKey] as StoreContext;
	return storeContext;
}

export function getStoreKey(element: HTMLElement, url: string, manifest: Manifest) {
	// Refactor to allow for static retrieval of the appParams
	const helper = new helpers.AppParamsHelper(element, url);
	const appParams = helper.getAppParamsFromElement();
	// Check if there is an explicit key that is supposed to be used for the store
	// that is defined on the element
	const {
		configurationKey = 'default',
		styleKey = 'default',
		applicationCode = '',
	} = appParams;

	const manifestStoreKey = `${ manifest.storeKey }-${ configurationKey }-${ styleKey }${ applicationCode.length > 0 ? `-${ applicationCode }` : '' }`;

	return appParams.storeKey || manifestStoreKey;
}